<template>
    <div class="progress">
        <div class='se-pre-con2'>
            <!-- <svg class='spinner' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'>
                <circle class='path' fill='transparent' stroke-width='4' cx='33' cy='33' r='30' stroke='url(#gradient)' />
                <linearGradient id='gradient'>
                    <stop offset='50%' stop-color='#050505' stop-opacity='1' />
                    <stop offset='65%' stop-color='#787878' stop-opacity='.5' />
                    <stop offset='100%' stop-color='#f2f2f2' stop-opacity='0' />
                </linearGradient>
            </svg> -->
            <div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.3); z-index: 10;">
            </div>
            <div style="top: 50%; left: 50%; transform: translate(-50%, -50%); position: absolute; z-index: 20;">
                <img class="rotate" :src="require('@/assets/img/reroad.png')" style="width: 60px;" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "customprogress",
}
</script>

<style scoped>
.progress {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 9999;
}

.se-pre-con2 {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
}

.se-pre-con2 .spinner {
    animation: rotate 1.4s linear infinite;
    -webkit-animation: rotate 1.4s linear infinite;
    -moz-animation: rotate 1.4s linear infinite;
    width: 50px;
    height: 50px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto
}

@keyframes rotate {
    to {
        transform: rotate(360deg);
    }
}

@-webkit-keyframes rotate {
    to {
        -webkit-transform: rotate(360deg);
    }
}

@-moz-keyframes rotate {
    to {
        transform: rotate(360deg);
    }
}

.rotate {
    animation: rotate 2.5s cubic-bezier(0.22, 0.21, 0.36, 1) infinite;
}

@keyframes rotate {
    0% {
        transform: rotate(0)
    }

    50% {
        transform: rotate(360deg)
    }

    100% {
        transform: rotate(0)
    }
}

.path {
    stroke-dasharray: 170;
    stroke-dashoffset: 20;
}
</style>